import Image from './Image';
import NavBar from './NavBar';
import React from 'react';
import Masonry from 'react-masonry-component';
import ToggleButton from './ToggleButton';

function App() {
  const [selected, setSelected] = React.useState(-1);
  const [revealed, setRevealed] = React.useState(false);

  let imageNumbers = [];
  for (let i = 0; i <= 23; i++) imageNumbers.push(i);
  const altTexts = [
  "Differently-sized triangles are projected onto a red curtain onstage, with audience members in the foreground.",
  "A large red rose.",
  "Bright red leaves on a tree.",
  "A large flower with pink petals.",
  "Red and yellow leaves on a tree.",
  "Orange leaves on a tree.",
  "Orange leaves on a tree, with blue sky and sunlight in the background.",
  "A worm’s eye view of a stone brick building with the blue sky in the background.",
  "Brown and yellow autumn leaves covering the ground.",
  "Bright yellow leaves on a tree.",
  "A tree with bright yellow leaves and a building in the background.",
  "A large flower with white and yellow petals.",
  "A large flower with yellow petals and green, spiky leaves.",
  "Green and yellow drinks from Junbi on a table.",
  "Bright and dark green leaves on trees.",
  "Bright red berries and dark green leaves on a bush.",
  "Green ivy growing on a brick building.",
  "Sunlight shining through a canopy of leaves.",
  "A small green tree in front of buildings with large reflective windows.",
  "A white cloud floats above a tree with green leaves under a blue sky.",
  "Purple flowers surrounded by green leaves.",
  "A Sharpie and watercolor cartoon-like drawing of a purple cat.",
  "An indigo light on a dorm building.",
  "A purple smiley-face vampire sticker on the sidewalk.",
  ];

  const masonryOptions = {
    gutter: 20,
    fitWidth: true
  };

  return (
    <>
      <NavBar />
      <div className="hero"></div>
            <div className="summary">
              <div style={{margin: '50px 0px'}}>
                <p><strong>PHOTO ESSAY | COLORS OF PRINCETON</strong></p>
                <p>A collection of images showcasing the various pockets of color found around Princeton — whether it be foliage, scenery, or a random Halloween sticker stuck to the sidewalk outside Nassau Hall, there is something of every color in the rainbow.</p>
                <br/>
                <p><em>Photos by Guanyi Cao</em></p>
                <p><em>Web design by Brian Tieu</em></p>
              </div>
                <hr/>
                <br/>
                <div style={{display: 'flex', alignItems: 'end', justifyContent: 'right', margin: '0px 0px 50px 0px'}}>
        {/* <button
          className={revealed ? 'desaturated-button' : 'saturated-button'}
          onClick={() => {
          setRevealed(prevRevealed => !prevRevealed)
        }}>{revealed ? "Desaturate" : "Saturate"}</button> */}
        <ToggleButton
          onClick={() => {setRevealed(prevRevealed => !prevRevealed)}}
          revealed={revealed}
        />
      </div>
            </div>

      <div className='grid-holder'>
      <Masonry
                className={'grid'} // default ''
                elementType={'div'} // default 'div'
                options={masonryOptions} // default {}
                // disableImagesLoaded={false} // default false
                // updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
                // imagesLoadedOptions={} // default {}
            >
          {imageNumbers.map(imageNumber => (
            <Image
              blackwhite={!revealed && selected !== imageNumber}
              hover={() => setSelected(imageNumber)}
              leave={() => setSelected(-1)}
              key={imageNumber}
              alt={altTexts[imageNumber]}
              link={`https://assets.dailyprincetonian.com/projects.dailyprincetonian.com/colors-of-princeton/${imageNumber}.jpg`}
            />
          ))}
      </Masonry>
      </div>
    </>
  );
}

export default App;
